"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { Menu, X } from "lucide-react";
import { RawButton } from "@/components/atoms/RawButton";
import { Box } from "@/components/atoms/Box";
import { Text } from "@/components/atoms/Text";
interface HamburgerButtonProps {
  isOpen: boolean;
  onToggle: () => void;
  isTransparent: boolean;
}
export const HamburgerButton = t0 => {
  const $ = _c(13);
  const {
    isOpen,
    onToggle,
    isTransparent
  } = t0;
  const t1 = !isTransparent || isOpen ? "text-muted-foreground border-border" : "text-white border-white/20";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("relative flex size-10 lg:hidden items-center justify-center border rounded-md", "transition-colors duration-200 ease-in-out", "hover:bg-accent/50", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isOpen ? "Close main menu" : "Open main menu";
  const t4 = isOpen ? "Close main menu" : "Open main menu";
  let t5;
  if ($[2] !== t4) {
    t5 = <Text className="sr-only">{t4}</Text>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isOpen) {
    t6 = <Box className="relative size-6 flex items-center justify-center">{isOpen ? <X className="size-6" /> : <Menu className="size-6" />}</Box>;
    $[4] = isOpen;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isOpen || $[7] !== onToggle || $[8] !== t2 || $[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <RawButton className={t2} onClick={onToggle} aria-expanded={isOpen} aria-controls="mobile-nav" aria-label={t3}>{t5}{t6}</RawButton>;
    $[6] = isOpen;
    $[7] = onToggle;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};